export const getDefaultFilter = (type: 'driver' | 'mixer' | 'employee') => {
  if(type === 'driver') {
    return ["postId","=", 3];
  }

  if(type === 'mixer') {
    return ["postId","=", 2];
  }

  if(type === 'employee') {
    return  [["postId","<>", 2], 'and', ['postId', '<>', 3]];
  }

  return []
}